module.exports = __webpack_public_path__ + "img/组 48.28cf3abd.png";